import React, { useState } from 'react'
import styles from './JobCard.module.css'
import ActionPanel from './ActionPanel'

const JobCard = ({ job }) => {
    const [isExpanded, setIsExpanded] = useState(false)

    return (
        <div className={`${styles.card} ${isExpanded ? styles.expanded : ''}`}>
            {/* Collapsed View */}
            <div className={styles.header} onClick={() => setIsExpanded(!isExpanded)}>
                <div className={styles.headerLeft}>
                    <h3 className={styles.jobTitle}>{job.title}</h3>
                    <p className={styles.company}>{job.company}</p>
                    <div className={styles.meta}>
                        {job.location && <span className={styles.metaItem}>📍 {job.location}</span>}
                        {job.type     && <span className={styles.metaItem}>💼 {job.type}</span>}
                        {job.readTime && <span className={styles.metaItem}>⏱️ {job.readTime}</span>}
                    </div>
                </div>
                <div className={styles.headerRight}>
                    <div className={styles.matchBadge}>
                        <span className={styles.matchPercent}>{job.match}%</span>
                        <span className={styles.matchLabel}>match</span>
                    </div>
                    <button className={styles.expandButton}>
                        {isExpanded ? '▲' : '▼'}
                    </button>
                </div>
            </div>

            {/* Expanded View */}
            {isExpanded && (
                <div className={styles.expandedContent}>
                    {job.whyMatch && job.whyMatch.length > 0 && (
                        <div className={styles.whyMatch}>
                            <h4 className={styles.sectionHeading}>WHY IS IT A STRONG MATCH?</h4>
                            <ul className={styles.matchList}>
                                {job.whyMatch.map((reason, index) => (
                                    <li key={index} className={styles.matchItem}>
                                        <span className={styles.checkIcon}>✓</span>
                                        {reason}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {job.actions && job.actions.length > 0 && (
                        <ActionPanel actions={job.actions} />
                    )}

                    {job.url && (
                        <a
                            href={job.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.jobLink}
                            onClick={e => e.stopPropagation()}
                        >
                            View Job →
                        </a>
                    )}
                </div>
            )}
        </div>
    )
}

export default JobCard
